import { Box } from '@mantine/core';
import { IconAlertCircle, IconClock, IconInbox, IconPencil, IconSend, IconTrash } from '@tabler/icons';
import { FC, useContext } from 'react';
import { NavigateFunction, useLocation, useNavigate } from 'react-router-dom';
import NavigationLink from '../../Atoms/Navigation/NavigationLink';
import EmailSearchTextInputField from '../../Molecules/Postbox/EmailSearchTextInputField';
import { useNavigationItem } from '../../Organismns/Navigation/NavigationItemHook';
import { WindowContext } from '../../Service/Context/WindowContext';
import { PostboxCountersContext } from '../../Service/Context/PostboxCountersContext';
import { ThemeTitle } from '../../Atoms/ThemeText';
import EmailBoxCounter from './EmailBoxCounter';

const EmailInboxNavLinks: FC<{ closeNavBar: () => void }> = ({ closeNavBar }) => {
  const navigate: NavigateFunction = useNavigate();
  const { pathname } = useLocation();
  const { sm } = useContext(WindowContext);

  // eslint-disable-next-line no-underscore-dangle
  const _onClick = (path: string) => {
    navigate(path);
    closeNavBar();
  };

  const { unreadCount, unassignedCount, draftsCount, scheduledCount, failedCount, trashCount } =
    useContext(PostboxCountersContext);

  return (
    <>
      {!sm && (
        <ThemeTitle p="md" order={3}>
          Postfach
        </ThemeTitle>
      )}
      <Box p="xs">
        <EmailSearchTextInputField />
      </Box>
      <NavigationLink opened label="Posteingang" icon={sm && <IconInbox size={16} />} childrenOffset={28}>
        <NavigationLink
          label="Alle"
          active={pathname === '/postbox/inbox'}
          onClick={() => _onClick('/postbox/inbox')}
          variant="filled"
        />
        <NavigationLink
          label="Unerledigt"
          active={useNavigationItem('/postbox/inbox/unread')}
          onClick={() => _onClick('/postbox/inbox/unread')}
          variant="filled"
          rightSection={<EmailBoxCounter count={unreadCount} />}
        />
        <NavigationLink
          label="ohne Eventbezug"
          active={useNavigationItem('/postbox/inbox/unassigned')}
          onClick={() => _onClick('/postbox/inbox/unassigned')}
          variant="filled"
          rightSection={<EmailBoxCounter count={unassignedCount} />}
        />
      </NavigationLink>
      <NavigationLink
        label="Gesendet"
        icon={sm && <IconSend size={16} />}
        active={useNavigationItem('/postbox/outbound')}
        onClick={() => _onClick('/postbox/outbound')}
        variant="filled"
      />
      <NavigationLink
        label="Entwürfe"
        icon={sm && <IconPencil size={16} />}
        active={useNavigationItem('/postbox/drafts')}
        onClick={() => _onClick('/postbox/drafts')}
        variant="filled"
        rightSection={<EmailBoxCounter count={draftsCount} />}
      />
      <NavigationLink
        label="Geplant"
        icon={sm && <IconClock size={16} />}
        active={useNavigationItem('/postbox/scheduled')}
        onClick={() => _onClick('/postbox/scheduled')}
        variant="filled"
        rightSection={<EmailBoxCounter count={scheduledCount} />}
      />
      <NavigationLink
        label="Fehlgeschlagen"
        icon={sm && <IconAlertCircle size={16} />}
        active={useNavigationItem('/postbox/failed')}
        onClick={() => _onClick('/postbox/failed')}
        variant="filled"
        rightSection={<EmailBoxCounter count={failedCount} />}
      />
      <NavigationLink
        label="Papierkorb"
        icon={sm && <IconTrash size={16} />}
        active={useNavigationItem('/postbox/trash')}
        onClick={() => _onClick('/postbox/trash')}
        variant="filled"
        rightSection={<EmailBoxCounter count={trashCount} />}
      />
    </>
  );
};

export default EmailInboxNavLinks;
